import { DialogConfig } from '@agent-ds/shared/components/dialog/dialog-config';
import { DialogRef } from '@agent-ds/shared/components/dialog/dialog-ref';
import { DialogService, DynamicFieldService, JobApiService, ProgressApiService, StudentApiService } from '@agent-ds/shared/services';
import { Component, OnDestroy, OnInit } from '@angular/core';
// import { CounselingMemoUploadType as UploadType } from '@agent-ds/shared/enums';
import { Job, JobScreeningInfo, Progress, ProgressSubScreeningStatus, StudentDetail } from '@agent-ds/shared/interfaces';
import { DynamicField, FormMeta } from '@agent-ds/shared/models';
import { Subscription } from 'rxjs';
import {
  JobScreeningInfoType,
  JobScreeningInfoTypes
} from '@agent-ds/shared/interfaces';
import { ProgressSubScreeningStatusCodes } from '@agent-ds/shared/enums/progress-status-code.enum';
// import { CounselingMemoConfirmDialogComponent } from '@agent-ds/student/components/counseling-memo-confirm-dialog/counseling-memo-confirm-dialog.component';
// import { SituationMemo, CounselingMemo } from '@agent-ds/shared/interfaces/memo';
import * as moment from 'moment';

@Component({
  selector: 'ag-progress-sub-screening-start-dialog',
  templateUrl: './progress-sub-screening-start-dialog.component.html',
  styleUrls: ['./progress-sub-screening-start-dialog.component.scss'],
})
export class ProgressSubScreeningStartDialogComponent implements OnInit, OnDestroy {
  constructor(
    private dialogService: DialogService,
    private dynamicService: DynamicFieldService,
    private jobApiService: JobApiService,
    private progressApiService: ProgressApiService,
    public dialog: DialogRef,
    public config: DialogConfig<{ progress: Progress }>,
  ) {}

  saving: boolean = false;
  progress: Progress;
  jobScreeningInfoList: JobScreeningInfo[] = [];
  selectableJobScreeningInfoLabels: string[] = [];
  selectedJobScreeningInfoData: JobScreeningInfo;
  jobScreeningInfoDataModel: {
    selectedJobScreeningInfoLabel: string,
    jobScreeningInfo: JobScreeningInfo,
  };
  jobScreeningInfoMeta: FormMeta;
  jobScreeningInfo2Meta: FormMeta;
  emptyMessage: string = 'サブステータス情報が未登録です。求人詳細ページで登録してください。';
  private fieldSubscription: Subscription;
  private jobScreeningInfoSubscription: Subscription;

  ngOnInit() {
    this.progress = this.config.data.progress;
    this.jobScreeningInfoDataModel = {
      selectedJobScreeningInfoLabel: '',
      jobScreeningInfo: this.selectedJobScreeningInfoData
    }
    this.fieldSubscription = this.dynamicService.fieldUpdateEvent.subscribe(() => {
      this.initFieldsMeta();
    });
    this.fetchJobScreeningInfoList();
  }

  ngOnDestroy() {
    if(this.fieldSubscription) {
      this.fieldSubscription.unsubscribe();
      this.fieldSubscription = null;
    }
    if(this.jobScreeningInfoSubscription) {
      this.jobScreeningInfoSubscription.unsubscribe();
      this.jobScreeningInfoSubscription = null;
    }
  }

  private fetchJobScreeningInfoList(): void {
    if (!this.progress || !this.progress.jobId) return;

    if (this.jobScreeningInfoSubscription) {
      this.jobScreeningInfoSubscription.unsubscribe();
      this.jobScreeningInfoSubscription = null;
    }

    this.jobScreeningInfoSubscription = this.jobApiService
      .getJobScreeningInfoList(this.progress.jobId)
      .subscribe((res) => {
        // null/undefined を除去
        this.jobScreeningInfoList = (res || []).filter((x) => !!x && !!x.type);
        
        // 既存のJobScreeningInfoで使用されているtypeを取得
        this.selectableJobScreeningInfoLabels =
          this.jobScreeningInfoList.map(
            info => this.getJobScreeningInfoLabel(info)
          ).filter(type => !!type);
        
        // フォームメタを初期化
        this.initFieldsMeta();
      });
  }

  private initFieldsMeta() {
    this.jobScreeningInfoMeta = {
      disabled: false,
      initTouched: true,
      groups: [
        {
          title: 'サブステータス',
          class: 'form__group--green-title-border',
          rows: [
            ...this.dynamicService.getFormRows(
              {
                fieldName: 'selectedJobScreeningInfoLabel',
                fieldType: 'list',
                label: '選考情報',
                displayType: 'dropdown',
                validationStyle: {
                  required: true,
                  options: [
                    ...this.selectableJobScreeningInfoLabels,
                  ],
                },
              },
              null,
              'full substatus__dropdown',
            ),
          ],
        },
      ],
    };
    this.jobScreeningInfo2Meta = {
      disabled: true,
      initTouched: true,
      groups: [
        {
          title: 'サブステータス詳細',
          class: 'form__group--green-title-border',
          rows: [
            ...this.dynamicService.getFormRows(
              {
                "model": "job",
                "fieldName": "jobScreeningInfo",
                "fieldType": "screening-info",
                "label": "サブステータス情報",
                "isCustomField": false,
                "displayType": "screening-info",
                "displayStyle": {},
                "isSearchable": false,
                "validationStyle": {},
                "searchStyle": {},
                "unit": ""
              }
            ),
          ],
        },
      ],
    };
  }

  public onJobScreeningInfoChanged(key: string): void {
    // typeフィールドが変更された場合、対応するJobScreeningInfoを更新
    if (key === 'selectedJobScreeningInfoLabel') {
      const selectedJobScreeningInfoLabel = this.jobScreeningInfoDataModel.selectedJobScreeningInfoLabel;
      if (selectedJobScreeningInfoLabel) {
        const selectedInfo = this.jobScreeningInfoList.find(
          info => this.getJobScreeningInfoLabel(info) === selectedJobScreeningInfoLabel
        );
        if (selectedInfo) {
          this.selectedJobScreeningInfoData = { ...selectedInfo };
          // jobScreeningInfoDataModelも更新
          this.jobScreeningInfoDataModel = {
            selectedJobScreeningInfoLabel,
            jobScreeningInfo: { ...selectedInfo }
          };
        }
      }
    }
  }

  public isValidJobScreeningInfoData(): boolean {
    return !!this.selectedJobScreeningInfoData &&
      !!this.selectedJobScreeningInfoData.type;
  }

  public close(): void {
    this.dialog.close();
  }

  public start(): void {
    if (!this.isValidJobScreeningInfoData() || !this.progress || !this.progress.id) {
      // 必須の type が未選択
      return;
    }
    if (this.saving) return;
    this.saving = true;

    // 選択されたtypeに対応するJobScreeningInfoを取得
    const selectedJobScreeningInfo = this.jobScreeningInfoList.find(
      info => info.id === this.selectedJobScreeningInfoData.id
    );

    if (!selectedJobScreeningInfo || !selectedJobScreeningInfo.id) {
      this.saving = false;
      return;
    }

    // ProgressSubScreeningStatusのペイロードを構築
    const now = moment();
    // DTOはnumberを期待するが、インターフェースはstringなので型アサーションを使用
    const payload: any = {
      jobScreeningInfoId: selectedJobScreeningInfo.id,
      registerUserId: 0, // バックエンドで設定される
      registeredAt: now.unix(), // epoch秒（INT UNSIGNED）として数値で送信（DTOの要件に合わせる）
      status: ProgressSubScreeningStatusCodes.設定中, // デフォルトステータス: 設定中
      remarks: null,
      mainStatus: this.progress.status,
      mainN: this.progress.n,
    };

    this.progressApiService.startProgressSubScreening(this.progress.id, payload).subscribe(
      () => {
        this.saving = false;
        // 親側で拾えるように返す（必要なら）
        this.dialog.close({ saved: true });
      },
      () => {
        this.saving = false;
      },
    );
  }

  private toNullableInt(v: any): number | null {
    if (v === '' || v === undefined || v === null) return null;
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
  }

  private getJobScreeningInfoLabel(info: JobScreeningInfo): string {
    return `${info.type}${info.no}`;
  }
}
